import { Box, IconButton, Typography } from '@mui/material';
import { CloseIcon } from '@icons';
import { ReactComponent as BackIcon } from '@public/images/arrow_back.svg';
import { IHeader } from './interfaces';
import { useStyles } from './styles';

const Header = ({ text = '', onClose, onBack }: IHeader) => {
  const classes = useStyles();

  return (
    <Box sx={classes.header(!!text)}>
      {onBack ? (
        <IconButton sx={classes.buttonIcon} onClick={onBack}>
          <BackIcon />
        </IconButton>
      ) : null}
      {text ? (
        <Box sx={classes.headerText}>
          <Typography sx={classes.text}>{text}</Typography>
        </Box>
      ) : null}
      <Box sx={classes.actions(!onBack)}>
        <IconButton sx={classes.buttonIcon} onClick={onClose}>
          <CloseIcon sx={classes.closeIcon} />
        </IconButton>
      </Box>
    </Box>
  );
};

export default Header;
